import { render } from "./List.vue?vue&type=template&id=4003e038&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=4003e038&scoped=true&lang=css"
import "./List.vue?vue&type=style&index=1&id=4003e038&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4003e038"]])

export default __exports__